import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
export {
	BULK_ISSUE_CREATE_SIDE_PANEL_ID,
	BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH,
	ROVO_BULK_CREATE_SIDE_PANEL_WIDTH,
} from '../src/ui/bulk-work-create-common/BulkCreateSidePanel.tsx';
export const BulkCreateSidePanel: LoadableType<{
	onClose: () => void;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkCreateSidePanel" */ '../src/ui/bulk-work-create-common/BulkCreateSidePanel.tsx'
			)
		).BulkCreateSidePanel,
});
